import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import back from "../../assets/images/elements/aboutHeader.jpg"; // Можна замінити на профільне фото або інший фон
import articlePdf from "../../resources/4_resilience.pdf"

export const Article4Resilience = () => {
    return (

        <section className='text_container_light'>
            <div className='container_100'>
                {/* Верхній блок з заголовком (як у About) */}
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle4Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    {/* Кнопка повернення */}
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА: Метадані та Анотація */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle4Title")}</h2>


                            <div style={{ marginTop: '10px' }}>
                                <a
                                    href={articlePdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-download-link"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: '#b22222',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>📄</span>
                                    {t("resourceArticleDownloadOriginal")}
                                </a>
                            </div>

                            <hr />
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle4AnnotationHeader")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_1") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle4Sec1")}</h3>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_6") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_8") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_9") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_10") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_11") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_12") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_13") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_14") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_15") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_16") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_17") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_18") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_19") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_20") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_21") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_22") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_23") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_24") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_25") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_26") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_27") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_28") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_29") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_30") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_31") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_32") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P1_33") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle4Sec2")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P2_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P2_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P2_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P2_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P2_5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P2_6") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P2_7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P2_8") }} /></p>

                            <br />
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P3_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P3_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P3_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P3_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P3_5") }} /></p>

                            <br />

                            <h3 className='menuColor'>{t("resourceArticle4Sec4")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_6") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_8") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_9") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_10") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_11") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P4_12") }} /></p>

                            <br />

                            <h3 className='menuColor'>{t("resourceArticle4Sec5")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_6") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_8") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_9") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_10") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_11") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_12") }} /></p>


                        </div>

                        {/* ПРАВА КОЛОНКА: Основний зміст */}
                        <div>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_13") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_14") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_15") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_16") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_17") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_18") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_19") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_20") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P5_21") }} /></p>

                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle4Sec6")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_6") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_8") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_9") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_10") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_11") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_12") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_13") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_14") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_15") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_16") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_17") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_18") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P6_19") }} /></p>

                            <br/>
                            <h3 className='menuColor'>{t("resourceArticle4Sec7")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_6") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_8") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_9") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_10") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_11") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_12") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_13") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_14") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_15") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_16") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P7_17") }} /></p>

                            <br/>
                            <h3 className='menuColor'>{t("resourceArticle4Sec8")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P8_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4P8_2") }} /></p>

                            <br/>
                            <h3 className='menuColor'>{t("resourceArticle1BibliographyHeader")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle4Bibliography") }} /></p>

                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle4Copyright")}
                            </p>
                            <br/>

                        </div>
                    </div>
                </div>
                <br />
            </div>
        </section>
    )
}
